
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 40C0 17.909 17.909 0 40 0s40 17.909 40 40-17.909 40-40 40S0 62.091 0 40z","fill":"#6D6F7B"}}),_c('path',{attrs:{"d":"M64.77 68.578A37.672 37.672 0 0140 77.818a37.672 37.672 0 01-24.77-9.24c2.06-.952 4.232-1.648 6.298-2.31 4.607-1.478 8.683-2.785 9.792-6.371V53.66c-1.303-.69-5.024-5.47-5.417-9.206-.04-.378-.365-.627-.794-.953-.815-.621-2.003-1.527-2.314-4.149-.255-2.148.758-3.357 1.371-3.737 0 0-1.527-3.466-1.527-6.903C22.639 18.487 27.726 10 40 10c6.627 0 8.681 4.675 8.681 4.675 5.92 0 8.681 6.46 8.681 14.038 0 3.777-1.528 6.903-1.528 6.903.614.38 1.627 1.59 1.372 3.737-.475 4.002-2.084 5.015-3.108 5.102-.393 3.73-4.115 8.51-5.417 9.206v6.236c1.109 3.586 5.185 4.893 9.791 6.37 2.066.663 4.239 1.36 6.298 2.311z","fill":"#fff"}})])
          )
        }
      }
    